import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const AnnotationLabelAlign = z.enum([
  'left',
  'center',
  'right',
]);
export type AnnotationLabelAlign = z.infer<typeof AnnotationLabelAlign>;

export const AnnotationLabelAlignArray = Object.values(AnnotationLabelAlign.enum).map(value => { return { value: value, name: 'enum.annotation_label.' + value }; });

export const AnnotationLabelAlignIcon: Record<string, string> = {
  [AnnotationLabelAlign.enum.left]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ALIGN_LEFT,
  [AnnotationLabelAlign.enum.center]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ALIGN_CENTER,
  [AnnotationLabelAlign.enum.right]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ALIGN_RIGHT,
}

export const MarkerBackgroundSchema = z.object({
  color: z.string().max(255).nullable().default(null),
  opacity: z.number().default(0),
});

export type MarkerBackground = z.infer<typeof MarkerBackgroundSchema>;

export const AnnotationLabelSchema = BaseSchema.extend({
  text: z.string().max(255),
  description: z.string().nullable().default(null),
  align: z.string().max(255).nullable().default(null),
  pivot: z.string().max(255).nullable().default(null),
  color: z.string().max(255).nullable().default(null),
  border: z.boolean().default(false),
  hidden: z.boolean().default(false),
  borderColor: z.string().max(255).nullable().default(null),
  borderWidth: z.number().nullable().default(null),
  fontSize: z.number().nullable().default(null),
  background: MarkerBackgroundSchema.optional(),
  annotation: z.string().uuid().optional()
});

export type AnnotationLabel = z.infer<typeof AnnotationLabelSchema>;

export const AnnotationLabelEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: AnnotationLabelSchema,
});

export type AnnotationLabelEntityQueryResult = z.infer<typeof AnnotationLabelEntityQueryResultSchema>;
